<template>
  <span
    class="more-actions"
    :class="{ open : isDropdownOpen, dropup: showAbove, dropdown: !showAbove }"
    v-on-clickaway="closeDropdown"
    style="display: inline-block; width: 35px;"
  >
    <a
      href="#"
      data-toggle="dropdown"
      class="dropdown-toggle"
      v-tooltip.bottom="'Actions'"
      @click.prevent="openDropdown"
    >
      <i class="fas fa-ellipsis-v"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-right" ref="dropdownMenu">
      <div class="export selector grid-filter">
        <div class="container-">
          <div class="row">
            <div class="col-md-12">
              <ul class="types" v-if="params">
                <li v-for="(action, i) in params.actions">
                  <component :is="component(action)" class="action" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'more-actions',

  mixins: [ clickaway ],

  props: {
    actions: Array
  },

  data() {
    return {
      isDropdownOpen: false,
      showAbove: false,
      component: action => ({
        template: action.tpl,
        data: () => ({
          params: this.params
        })
      })
    }
  },

  computed: {
    //
  },

  created() {
    //
  },

  methods: {
    openDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
      this.params.context.shownPopover = this.isDropdownOpen

      this.showAbove || this.$nextTick(() => {
        const gridBounds = this.params.context.$el.querySelector('.ag-body').getBoundingClientRect()
        const menuBounds = this.$refs.dropdownMenu.getBoundingClientRect()
        const gridBottomEdge = gridBounds.top + gridBounds.height
        const menuBottomEdge = menuBounds.top + menuBounds.height

        this.showAbove = menuBottomEdge > gridBottomEdge
      })
    },

    closeDropdown() {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false
      }
    }
  }
}

</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

.dropdown, .dropup {
  a.dropdown-toggle:not(.btn) {
    @include theme { color: v(border) };
    padding-left: 10px;
    padding-right: 10px;

    &:hover {
      @include theme {
        color: v(ink);
        background-color: v(background-light);
      };
    }
  }

  .dropdown-menu {
    display: none;
    min-width: 100px;
  }
  &.open .dropdown-menu {
    display: block;
  }
}

.types {
  list-style: none;
  padding: 0;
  margin: 0;
}

.action {
  display: block;
  
  >>> a {
    &:hover, &:focus, &:active {
      background-color: unset;
    }
    &:before {
      display: none;
    }
    &:after {
      content: attr(data-name);
    }
    &.fa, &.fas, &.far, &.fal {
      font-family: unset;
      font-weight: 400;
      @include theme { color: v(ink) };
    }

    display: block;
    padding: 10px;
    cursor: pointer;

    &:hover {
      @include theme {
      background-color: v(background-light);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/MoreActions.vue